import { useEffect } from 'react';
import '@components/Admin/Toast.css';

function Toast({ id, title, message, type = 'info', duration = 5000, onClose }) {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose(id);
            }, duration);
            
            return () => clearTimeout(timer);
        }
    }, [duration, id, onClose]);
    
    const icons = {
        success: 'fas fa-check-circle',
        error: 'fas fa-exclamation-circle',
        warning: 'fas fa-exclamation-triangle',
        info: 'fas fa-info-circle'
    };
    
    return (
        <div className={`toast toast-${type} show`}>
            <div className="toast-icon">
                <i className={icons[type] || icons.info}></i>
            </div>
            <div className="toast-content">
                <div className="toast-title">{title}</div>
                <div className="toast-message">{message}</div>
            </div>
            <button className="toast-close" onClick={() => onClose(id)}>
                <i className="fas fa-times"></i>
            </button>
            {duration > 0 && (
                <div 
                    className="toast-progress" 
                    style={{ 
                        animation: `toastProgress ${duration}ms linear forwards` 
                    }}
                />
            )}
        </div>
    );
}

export default Toast;

